var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.3023 29.3333C3.16453 29.3333 3.03119 29.2889 2.91564 29.2044C2.76008 29.0844 2.66675 28.8978 2.66675 28.6978V10.4978C2.66675 6.17778 6.17786 2.66667 10.4979 2.66667H21.5023C25.8223 2.66667 29.3334 6.17778 29.3334 10.4978V19.52C29.3334 23.84 25.8223 27.3511 21.5023 27.3511H10.5823L3.47119 29.3111C3.41786 29.3244 3.36008 29.3333 3.3023 29.3333ZM10.4979 3.93778C6.88008 3.93778 3.93786 6.88 3.93786 10.4978V27.8667L10.329 26.1067C10.3823 26.0933 10.4401 26.0844 10.4979 26.0844H21.5023C25.1201 26.0844 28.0623 23.1422 28.0623 19.5244V10.5022C28.0623 6.88444 25.1201 3.94222 21.5023 3.94222H10.4979V3.93778Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1868 11.1555H16.1646C15.8179 11.1555 15.5334 10.8755 15.5334 10.5244C15.5334 10.1733 15.8134 9.89331 16.1646 9.89331H23.1868C23.5334 9.89331 23.8179 10.1733 23.8179 10.5244C23.8179 10.8755 23.5379 11.1555 23.1868 11.1555Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2002 16.4977H9.16016C8.8135 16.4977 8.52905 16.2177 8.52905 15.8666C8.52905 15.5155 8.80905 15.2355 9.16016 15.2355H23.2002C23.5468 15.2355 23.8313 15.5155 23.8313 15.8666C23.8313 16.2177 23.5513 16.4977 23.2002 16.4977Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2002 21.2978H9.16016C8.8135 21.2978 8.52905 21.0178 8.52905 20.6667C8.52905 20.3156 8.80905 20.0356 9.16016 20.0356H23.2002C23.5468 20.0356 23.8313 20.3156 23.8313 20.6667C23.8313 21.0178 23.5513 21.2978 23.2002 21.2978Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6623 13.0223C9.28895 13.0223 8.16895 11.9023 8.16895 10.5289C8.16895 9.15559 9.28895 8.03559 10.6623 8.03559C12.0356 8.03559 13.1556 9.15559 13.1556 10.5289C13.1556 11.9023 12.0356 13.0223 10.6623 13.0223ZM10.6623 9.29781C9.98228 9.29781 9.42672 9.85337 9.42672 10.5334C9.42672 11.2134 9.98228 11.7689 10.6623 11.7689C11.3423 11.7689 11.8978 11.2134 11.8978 10.5334C11.8978 9.85337 11.3423 9.29781 10.6623 9.29781Z",
    fill: "#C18344"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReview);
export default __webpack_public_path__ + "static/media/review.32771e41a8c35cf67a469b2338a3a96a.svg";
export { ForwardRef as ReactComponent };